import { WebappEstateFragment } from '@gql'
import { createModel } from '../../../store/generic'

export default createModel<WebappEstateFragment>()
